import React, {Component} from 'react';

var checkStyle = {
  fontFamily: 'sans-serif',
  color: 'red',
  height: '48px',
  width: '48px',

  backgroundColor: '#2ba1f4',
  borderRadius: '3px'
}

var checkMark = (
  <div style={checkStyle}>
    <img src="/checkmark_white.svg" alt="checkmark"/>
  </div>
)


class Toggle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    }
  }

  click() {
    var newState = !this.state.isChecked;
    (this.props.onChange || function() {})(newState)
    this.setState({isChecked: newState})
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forceClear) {
      this.setState({isChecked: false})
    }
  }

  render() {
    return (
      <div onClick={this.click.bind(this)}>
        {this.state.isChecked ? checkMark : this.props.children}
      </div>
    )
  }
}

export default Toggle;


// WEBPACK FOOTER //
// ./src/RollResults/Toggle.js